<template>
	<div v-if="user.hasRole(['manager', 'admin', 'staff'])">
		<div class="row">
			<div class="col-md-12">
				<buttons
					@reload="reload"
					:data="item"
					:user="user"
					:isAuth="isAuth">
				</buttons>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<template v-if="item">
					<datatable
						@reload="reload"
						ref="datatable"
						:isAuth="isAuth"
						:user="user"
						:agreement="item">
					</datatable>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	import Buttons from './../../../views/Buttons.vue'
	import Datatable from './../views/Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'buttons': Buttons,
			'datatable': Datatable,
		},
		data () {
			return {
				item: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
				this.$refs.datatable.reload()
			},
			getData () {
				this.$http.get('admin/agreements/' + this.$route.params.id + '/edit')
				.then(response => {
					this.item = response.body
				}).catch(response => {
					console.log(response)
					if(response.status == 423) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					} else {
						swal({
							title: response.statusText,
							text: response.body,
							type: 'warning',
						})
					}
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/agreements/components/recurrings/layout/Recurrings.vue